<template>
  <div class="equipment-config-container">
    <div class="content-wrapper" v-if="$route.path === '/dataView/special'">
      <div class="table-section">
        <div class="table-card">
          <div class="table-header">
            <span>医疗机构专题分析</span>
          </div>
          <el-table :data="tableData" border stripe style="width: 100%">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="orgName" label="医疗机构名称" width="300"></el-table-column>
            <el-table-column prop="orgCode" label="医疗机构编码" width="200"></el-table-column>
            <el-table-column prop="ct" label="CT数量"></el-table-column>
            <el-table-column prop="mri" label="MRI数量"></el-table-column>
            <el-table-column prop="petct" label="PET/CT数量"></el-table-column>
            <el-table-column prop="petmri" label="PET/MRI数量"></el-table-column>
            <el-table-column prop="spect" label="SPECT"></el-table-column>
            <el-table-column prop="dr" label="DR数量"></el-table-column>
            <el-table-column prop="other" label="其他设备"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button :disabled="disableDetail(scope.row)" @click="handleReview(scope.row)" type="primary" size="small">
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin: 10px 5px 10px 0;">
            <span>时间更新至2026年4月21日</span>
          </div>
        </div>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>

export default {
  name: 'SpecialConfig',
  data() {
    return {
      tableData: [
        { 
          orgName: '山东大学齐鲁医院',
          orgCode: '131023',
          ct: 11,
          dr: '',
          mri: 11,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '北京大学第三医院',
          orgCode: '131004',
          ct: 3,
          dr: '',
          mri: 7,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '华中科技大学同济医学院附属同济医院',
          orgCode: '131018',
          ct: 3,
          dr: '',
          mri: 7,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '中南大学湘雅医院',
          orgCode: '131020',
          ct: 4,
          dr: '',
          mri: 6,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '吉林大学中日联谊医院',
          orgCode: '125100004507',
          ct: 5,
          dr: '',
          mri: 2,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '中南大学湘雅二医院',
          orgCode: '131021',
          ct: 13,
          dr: '',
          mri: 16,
          petct: 3,
          petmri: 1,
          spect: '',
          other: ''
        },
        { 
          orgName: '中南大学湘雅三医院',
          orgCode: '131022',
          ct: 5,
          dr: '',
          mri: 7,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '中日友好医院',
          orgCode: '131030',
          ct: 8,
          dr: 3,
          mri: 7,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '中山大学附属第一医院',
          orgCode: '131060',
          ct: 4,
          dr: '',
          mri: 6,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '北京大学第一医院',
          orgCode: '131002',
          ct: 9,
          dr: '',
          mri: 10,
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '四川大学华西医院',
          orgCode: '12510000450756139Y',
          ct: 14,
          dr: '',
          mri: '',
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        },
        { 
          orgName: '西安交通大学第一附属医院',
          orgCode: '131014',
          ct: 5,
          dr: 2,
          mri: 6,
          petct: 1,
          petmri: '',
          spect: '',
          other: 5
        },
        { 
          orgName: '山东大学第二医院',
          orgCode: '12370000495573096D',
          ct: 7,
          dr: '',
          mri: '',
          petct: '',
          petmri: '',
          spect: '',
          other: ''
        }
      ]
    }
  },
  methods: {
    handleReview(data) {
      this.$router.push({
        path: '/dataView/special/specialDetail',
        query: {
          orgCode: data.orgCode,
          orgName: data.orgName
        }
      })
      
    },
    disableDetail(data) {
      return data.orgCode !== "131021"
    },
  }
}
</script>

<style lang="scss">
.equipment-config-container {
  padding: 20px;
  background-color: #f5f7fa;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 200px;
  flex: 1;
  max-width: 300px;

  label {
    font-size: 14px;
    color: #666;
  }

  .input-group {
    display: flex;
  }

  input,
  select {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 0;
    font-size: 14px;
    height: 36px;
  }

  .search-btn {
    padding: 0 15px;
    background-color: #0d6efd;
    color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
  }
}

.query-btn {
  padding: 8px 25px;
  background-color: #0d6efd;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  height: 36px;
  margin-bottom: 0;
}

.query-btn-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: auto;
  flex: none;
  max-width: auto;
}

.query-btn-wrapper button {
  margin-top: auto;
}

/* 统计与表格区域 */
.content-wrapper {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
}

/* 左侧统计卡片 */
.stats-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 0 0 calc(40% - 10px);
  min-width: 350px;
}

/* 右侧设备配置清单 */
.table-section {
  flex: 0 0 calc(60% - 10px);
  min-width: 350px;
}

.chart-card {
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0;

  .chart-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }

  .chart-container {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: 15px;
  }

  .chart-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 12px;
    color: #666;
  }
}

/* 右侧设备配置清单 */
.table-section {
  flex: 1;
  min-width: 500px;
}

.table-card {
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  overflow: hidden;
  padding: 0;
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.table-header span {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.table-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  padding: 5px 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 14px;
  border-radius: 0;
}

/* 表格样式 */
.table-scroll-container {
  overflow-x: auto;
  padding: 0;
  margin: 0;
}

.equipment-table th:nth-child(1),
.equipment-table td:nth-child(1) {
  text-align: center;
  width: 80px;
  /* 序号列固定宽度 */
}

.equipment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
  /* 设置固定布局 */
}

.equipment-table th {
  background-color: #f8f9fa;
  border: 1px solid #eee;
  padding: 12px 20px;
  text-align: left;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
  white-space: nowrap;
  /* 防止表头自动换行 */
  min-width: 100px;
  /* 最小宽度，可根据需要调整 */
}

.equipment-table td {
  border: 1px solid #eee;
  padding: 12px 20px;
  text-align: left;
  color: #666;
  line-height: 1.4;
  white-space: nowrap;
  /* 防止单元格自动换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 状态标签样式 */
.status {
  padding: 3px 10px;
  border-radius: 0;
  font-size: 12px;
  font-weight: normal;
}

.status-in-use {
  background-color: #e6f4ea;
  color: #198754;
}

.status-idle {
  background-color: #fff3cd;
  color: #ffc107;
}

.status-scrap {
  background-color: #f8d7da;
  color: #dc3545;
}

/* 金额样式 */
.price {
  font-weight: bold;
}

.price-high {
  color: #dc3545;
}

/* 操作按钮 */
.action-col {
  text-align: center;
}

.detail-btn {
  padding: 2px 10px;
  background-color: #0d6efd;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 12px;
  border-radius: 0;
}

/* 表格底部 */
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-top: 1px solid #eee;
  background-color: #f8f9fa;
}

.data-info {
  font-size: 14px;
  color: #666;
}

.highlight {
  color: #0d6efd;
  font-weight: bold;
}

/* 分页样式 */
.pagination {
  display: flex;
  gap: 5px;
}

.page-btn {
  padding: 5px 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 14px;
  border-radius: 0;
}

.page-btn:hover {
  background-color: #f8f9fa;
}

.page-btn.active {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}

.page-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-wrapper {
    flex-direction: row;
  }

  .stats-section {
    flex: 0 0 calc(30% - 10px);
  }

  .table-section {
    flex: 0 0 calc(70% - 10px);
  }

  .filter-bar {
    justify-content: space-between;
  }

  .filter-item {
    min-width: 180px;
  }
}

@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
  }

  .stats-section,
  .table-section {
    flex: 0 0 100%;
  }

  .filter-bar {
    justify-content: space-between;
  }

  .filter-item {
    min-width: 180px;
  }
}

@media (max-width: 768px) {
  .equipment-config-container {
    padding: 10px;
  }

  .filter-bar {
    padding: 15px;
    gap: 15px;
  }

  .filter-item {
    min-width: 100%;
    max-width: none;
    flex: none;
  }

  .stats-section {
    flex-direction: column;
  }

  .chart-card {
    flex: none;
    width: 100%;
  }

  .table-section {
    min-width: 100%;
  }

  .query-btn-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: auto;
    flex: none;
    max-width: auto;
  }

  .query-btn-wrapper button {
    margin-top: auto;
  }
}
</style>